exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-fathersday-rule .main[data-v-35a0307b] {\n  background: #fbf0cc;\n  border-radius: 3px;\n  padding: 15px;\n}\n.page-fathersday-rule .main .textcontent[data-v-35a0307b] {\n  background-color: #fff;\n  border-radius: 3px;\n  border: 0.5px solid #ffd597;\n}\n.page-fathersday-rule .main h3[data-v-35a0307b] {\n  padding: 10px 0;\n  text-align: center;\n  border-bottom: 5px solid #fbf0cc;\n  color: #454545;\n}\n.page-fathersday-rule .main .content[data-v-35a0307b] {\n  padding: 20px;\n}\n", ""]);

// exports
